module.exports = __webpack_public_path__ + "static/media/nestjs.c596eb94.svg";